import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DashboardService, type DashboardCombinedResponse } from "@/src/services/dashboard/dashboardService";

type DashboardState = {
  response: DashboardCombinedResponse | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
  lastFetchedAt: string | null;
};

const initialState: DashboardState = {
  response: null,
  status: "idle",
  error: null,
  lastFetchedAt: null,
};

export const fetchCombinedDashboard = createAsyncThunk<DashboardCombinedResponse, void, { rejectValue: string }>(
  "dashboard/fetchCombinedDashboard",
  async (_, { rejectWithValue }) => {
    try {
      return await DashboardService.getCombinedDashboard();
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || error?.message || "Failed to load dashboard data");
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCombinedDashboard.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCombinedDashboard.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.response = action.payload;
        state.error = null;
        state.lastFetchedAt = new Date().toISOString();
      })
      .addCase(fetchCombinedDashboard.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message || "Failed to load dashboard data";
      });
  },
});

export default dashboardSlice.reducer;
